var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCameraIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 9,
    viewBox: "0 0 13 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.34345 0C7.79666 0 8.81127 0.979167 8.81127 2.3824V6.4176C8.81127 7.82083 7.79666 8.8 6.34345 8.8H2.86822C1.415 8.8 0.400391 7.82083 0.400391 6.4176V2.3824C0.400391 0.979167 1.415 0 2.86822 0H6.34345ZM11.1752 1.39567C11.4386 1.26464 11.7476 1.27834 11.999 1.43319C12.2504 1.58745 12.4004 1.85547 12.4004 2.14851V6.65185C12.4004 6.94548 12.2504 7.2129 11.999 7.36716C11.8616 7.45114 11.708 7.49403 11.5532 7.49403C11.4242 7.49403 11.2952 7.46425 11.1746 7.40409L10.286 6.96573C9.95717 6.80253 9.75316 6.47495 9.75316 6.11104V2.68872C9.75316 2.32421 9.95717 1.99663 10.286 1.83463L11.1752 1.39567Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIcon);
export default __webpack_public_path__ + "static/media/cameraIcon.0d289a8d59b05d2a9907f690c7125216.svg";
export { ForwardRef as ReactComponent };